/*
 * TUMLE: "Fri fragt" under the options in the Kaching package picker (and our
 * own "Køb sammen", tumle_bundle) whose price reaches the free-shipping limit,
 * so the customer sees that two sets ship free and one set does not.
 * Shopify's rule in Denmark: free shipping from 495 kr (the shipping rates in
 * Shopify admin; change window.tumleFreeShipping.min in layout/theme.liquid
 * with them). Shown in Denmark only, in DKK. Re-applied when the app redraws
 * the picker. Styles in assets/tumle_main-product.css.
 */
(function () {
  var cfg = window.tumleFreeShipping;
  if (!cfg || !cfg.min) return;

  // The first amount in the text ("1 690 DKK" before a struck-out "1 840 DKK")
  function amount(text) {
    var m = /\d[\d\s.]*/.exec(text || '');
    return m ? Number(m[0].replace(/[^\d]/g, '')) : 0;
  }

  function mark(container, priceEl, place) {
    var free = amount(priceEl && priceEl.textContent) >= cfg.min;
    var tag = container.querySelector('.tumle_free-shipping');
    if (free && !tag) {
      tag = document.createElement('span');
      tag.className = 'tumle_free-shipping';
      tag.textContent = cfg.label;
      place(tag);
    } else if (!free && tag) {
      tag.remove();
    }
  }

  function apply() {
    document.querySelectorAll('.kaching-bundles__bar').forEach(function (bar) {
      var line = bar.querySelector('.kaching-bundles__bar-second-line');
      if (!line) return;
      // The total, when the option also shows a price per set
      var total = bar.querySelector('.kaching-bundles__bar-pricing-row--secondary .kaching-bundles__bar-price') || bar.querySelector('.kaching-bundles__bar-price');
      mark(bar, total, function (tag) { line.appendChild(tag); });
    });
    document.querySelectorAll('.tumle_bundle__option').forEach(function (option) {
      var name = option.querySelector('.tumle_bundle__name');
      if (!name) return;
      mark(option, option.querySelector('.tumle_bundle__price'), function (tag) { name.appendChild(tag); });
    });
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      apply();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();
